export default {
    new_migration_account: 'Cuenta',
    new_migration_accounts: 'Cuenta',
    new_migration_groups: 'Grupos',
    new_migration_landmarks: 'Puntos de interés',
    new_migration_landmark_groups: 'Grupos de puntos de interés',
    new_migration_server: 'Servidor',
    new_migration_account_name: 'Nombre de la cuenta',
    new_migration_no_data_available: 'No hay datos disponibles',
    new_migration_entity_to_migrate: 'Entidad a migrar',
    new_migration_contacts: 'Contactos',
    new_migration_categories: 'Categorias',
    new_migration_behavior: 'Comportamiento',
    new_migration_users: 'Usuarios',
    new_migration_drivers: 'Conductores',
    new_migration_devices: 'Dispositivos',
    new_migration_geofences: 'Geocercas',
    new_migration_maintenance: 'Mantenimiento',
    new_migration_import: 'Importar',
    new_migration_import_from_p4: 'Importar Cuenta',
    new_migration_import_from_account: 'Importar desde Cuenta',
    new_migration_records_found: 'Registros encontrados',
    MigrationExists: "La migración existe",
    MigrationNotExists: "La migración no existe",
    MigrationNotExists_AccountNameExists: "La migración no existe, pero el nombre de la cuenta ya existe",
    new_migration_success_message: "La migración comenzó a ejecutarse",
    new_migration_error_message: "No se ha podido ejecutar la migración debido a un error",
    new_migration_warning_message: "Es necesario verificar que el nombre de las cuentas P4 y PX seleccionadas coinciden",
    new_migration_account_registered: "Ya existe una cuenta registrada con el nombre",
    new_migration_in_px: "en PX",
    new_migration_verify_accounts: "Es necesario verificar que el nombre de las cuentas P4 y PX seleccionadas coinciden",
    new_migration_pair_with_this_px: "Emparejar con esta cuenta PX",
    new_migration_alerts: "Alertas",
    new_migration_speed_override: "Anulación de velocidad",
    new_migration_entities: "Entidades",
    new_migration_source: "Origen",
    new_migration_units_novidfleet: 'Unidades (NO Vidfleet)',
    new_migration_units_vidfleet: 'Unidades (Vidfleet)',
    new_migration_assets: 'Activos',
    new_migration_asset_subtypes: 'Subtipos de Activos',
    new_migration_tags: 'Etiquetas',
    new_migration_speed_overrides: 'Anulaciones de velocidad',
    new_migration_all: 'Todos',
    new_migration_selected: 'Selección',
    new_migration_selected_for: "Al menos una entidad debe ser seleccionada para",
    new_migration_title: 'Migración de Entidades TSO',
    new_migration_error_messages: "No se han podido sincronizar las entidades",
    new_migration_transaction_request_message: "Se ha recibido la solicitud de migración. Haga clic aquí para ver el estado de la importación",
    new_migration_gtc_account_name: "Nombre de la cuenta GTC",
    new_migration_ignition_account_name: "Nombre de la cuenta Ignition",
    new_migration_mode: "Modo",
    new_migration_mode_label: "Modo",
    new_migration_pair_with_this_gtc: "Emparejar con esta cuenta GTC",
    new_migration_select_integration_mode: "Seleccionar modo de integración",
    new_migration_preview_mode: "Modo de vista previa",
    new_migration_preview_mode_desc: "Datos de solo lectura para pruebas antes de la migración completa",
    new_migration_upgrade_mode: "Modo de actualización",
    new_migration_upgrade_mode_desc: "Migración completa: todas las entidades se sincronizan automáticamente cada 24 horas",

    new_migration_select_entities_to_sync: "Seleccionar entidades para sincronizar",
    new_migration_units: "Unidades",
    new_migration_assets_non_tcu: "Activos (sin TCU)",
    new_migration_roles: "Roles",
    new_migration_permissions: "Permisos",
    new_migration_divisions: "Divisiones",
    new_migration_zones_landmarks: "Zonas (Landmarks)",
    new_migration_entities_auto_synced: "Entidades (Auto-sincronizadas)",
    new_migration_upgrade_entities_locked: "En Modo de actualización, todas las entidades se sincronizan automáticamente y no se pueden personalizar.",

    new_migration_convert_to_upgrade_title: "¿Convertir a modo de actualización?",
    new_migration_convert_to_upgrade_desc: "Estás a punto de convertir esta integración de Modo de vista previa a Modo de actualización. Esta acción no se puede deshacer.",
    new_migration_what_will_happen: "Lo que ocurrirá:",
    new_migration_upgrade_bullet_sync_all_entities: "Todas las entidades se sincronizarán automáticamente",
    new_migration_upgrade_bullet_sync_every_24h: "Los datos se sincronizarán continuamente cada 24 horas",
    new_migration_upgrade_bullet_no_switch_back: "No podrás volver al Modo de vista previa",
    new_migration_upgrade_bullet_permanent: "Los cambios serán permanentes",
    new_migration_are_you_sure: "¿Estás seguro de que deseas continuar?",
    new_migration_cancel: "Cancelar",
    new_migration_confirm_convert_upgrade: "Sí, convertir a modo de actualización",
    new_migration_account_already_linked: "Esta cuenta GTC ya está enlazada con una cuenta destino y no se puede modificar esa relación.",
    new_migration_already_upgraded_desc: "Esta cuenta ya ha sido actualizada a modo 'upgrade' y no puede ser modificada.",
    new_migration_already_upgraded: "Cuenta ya actualizada",
    new_migration_preview_only_upgrade_desc: "Esta cuenta está en modo 'preview'. Solo puede actualizarse a modo 'upgrade'.",
    new_migration_preview_units_only_warning: "En modo de vista previa, si seleccionas Unidades, también debes seleccionar al menos otra entidad (Activos, Conductores o Usuarios).",
    new_migration_upgrade_already_done: "Migración marcada como actualización ya realizada. No se puede continuar con el proceso.",
    new_migration_warning_multiple_legacy_accounts: "La empresa seleccionada es una empresa de múltiples cuentas, solo se pueden migrar empresas individuales en este momento.",
    new_migration_gtc_account_missing_account_code: "La cuenta GTC seleccionada no tiene un Código de Cuenta y no se puede usar para la migración."
}